import { SxProps, Theme } from '@mui/material';
import { headerHeight } from 'services/navigation/components/PrivateRoute';

const container: SxProps<Theme> = {
  position: 'relative',
  height: '100%'
};

const loadingOverlay: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,
  pointerEvents: 'all',
  cursor: 'wait'
};

const panelGroupStyle = {
  height: '100%'
};

const leftPanelStyle = {
  overflowY: 'auto' as const,
  overflowX: 'hidden' as const,
  maxHeight: `calc(100vh - ${headerHeight}px)`,
  zIndex: 1
};

const mainContainerStack = (
  layoutContainerPaddingX: string,
  layoutContainerPaddingY: string
): SxProps<Theme> => ({
  pl: layoutContainerPaddingX,
  py: layoutContainerPaddingY,
  // Grows past the panel so the sticky rail has the full scroll to stick over.
  minHeight: `calc(100vh - ${headerHeight}px)`,
  // On the content, not the panel: the panel is content-box, so padding there
  // would push its bottom past the viewport.
  pb: 'calc(var(--popp-action-bar-height, 0px) + var(--popp-scrollbar-inset, 8px))'
});

const getPanelResizeHandleStyle = (primaryColor: string) => ({
  width: '1px',
  backgroundColor: primaryColor,
  cursor: 'col-resize',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative' as const,
  zIndex: 1202
});

const conversationPanelStyle = {
  backgroundColor: 'white',
  boxShadow: '0px 0px 6px 0px rgba(40, 39, 44, 0.50)',
  overflowY: 'auto' as const,
  maxHeight: `calc(100vh - ${headerHeight}px)`,
  zIndex: 1201
};

const resizeHandle: SxProps<Theme> = {
  width: '15px',
  height: '30px',
  borderRadius: '15px',
  border: (theme) => `1px solid ${theme.palette.primary.main}`,
  background: '#FFF',
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  cursor: 'auto',
  boxShadow: '-3px 0px 6px 0px rgba(40, 39, 44, 0.30)'
};

export const candidateProfileTableSx = {
  container,
  loadingOverlay,
  panelGroupStyle,
  resizeHandle,
  leftPanelStyle,
  mainContainerStack,
  getPanelResizeHandleStyle,
  conversationPanelStyle
};
